<template>
<article class="info-section elr-container-full">
  <div class="elr-row">
    <div class="elr-col-full">
      <div class="info-section-header">
        <info-section-heading>Categories</info-section-heading>
        <p class="info-section-description">List of all the categories</p>
      </div>
    </div>
  </div>
  <div class="elr-row">
    <div class="elr-col-full">
      <ul>
        <li>Body Color</li>
        <li>Hair Color</li>
        <li>Body Texture</li>
        <li>Age</li>
        <li>Gender</li>
        <li>Symbol Type</li>
        <li>Eye Type</li>
        <li>Symbol Texture</li>
      </ul>
    </div>
  </div>
</article>
</template>

<script>
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';

export default {
  name: 'Categories',
  computed: {
    user() {
      return this.$store.state.currentUser.currentUser;
    }
  },
  components: {
    InfoSectionHeading
  }
};
</script>
